module.exports = __webpack_public_path__ + "45ffbbf4a874d22d49416a018e01cc9d.svg";